<template>
    <!-- eslint-disable -->
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="50" height="50" viewBox="0 0 50 50">
        <defs>
            <clipPath id="clip-Menu_profil">
                <rect width="50" height="50" />
            </clipPath>
        </defs>
        <g id="Menu_profil" data-name="Menu profil" clip-path="url(#clip-Menu_profil)">
            <g id="noun_avatar_2309777" transform="translate(-541.025 -538.57)">
                <g id="Groupe_3053" data-name="Groupe 3053" transform="translate(555.529 553.529)">
                    <path id="Tracé_3084" data-name="Tracé 3084" d="M10.8,289.063A10.275,10.275,0,1,0,21.08,299.338,10.287,10.287,0,0,0,10.8,289.063Zm0,3.67a3.67,3.67,0,1,1-3.67,3.67A3.681,3.681,0,0,1,10.8,292.732ZM7.869,301.54H13.74a3.677,3.677,0,0,1,3.667,3.621,8.8,8.8,0,0,1-13.206,0A3.677,3.677,0,0,1,7.869,301.54Z" transform="translate(-0.529 -289.063)" :fill="color" />
                </g>
            </g>
        </g>
    </svg>
</template>
<script>
import { Colorable } from '../../mixins';

export default {
    name: 'IconProfile',
    mixins: [Colorable],
};
</script>
